import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoyaltyTier, TierQuery, TierService } from '@fgb/core';
import { firstValueFrom, Observable, Subject, takeUntil, tap } from 'rxjs';
import { MemberQuery } from '@fgb/core';

@Component({
  selector: 'fgb-tier-level-page',
  templateUrl: './tier-level-page.component.html',
  styleUrl: './tier-level-page.component.scss',
})
export class TierLevelPageComponent implements OnInit, OnDestroy {
  tierName: string;
  tierLevels$: Observable<LoyaltyTier[]>;
  selectedIndex: number;
  private _destroyed$ = new Subject<void>();

  constructor(
    private memberQuery: MemberQuery,
    private tierService: TierService,
    private tierQuery: TierQuery
  ) {}

  ngOnInit() {
    this.tierName = this.memberQuery.getUserContext().tierName;

    firstValueFrom(this.tierService.fetchTiers(this.memberQuery.getClubId()));
    this.tierLevels$ = this.tierQuery.selectAll().pipe(
      takeUntil(this._destroyed$),
      tap((tier) => {
        // Find the index of the selected tier
        this.selectedIndex = tier.findIndex((t) => t.Name === this.tierName);
      })
    );
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
